module.exports = __webpack_public_path__ + "img/P2.8da07c7.png";